module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ed-Fb-Gb.6b61b498.png";